import { render, staticRenderFns } from "./emitLipscolorchanger.vue?vue&type=template&id=0b4958da&scoped=true"
import script from "./emitLipscolorchanger.vue?vue&type=script&lang=js"
export * from "./emitLipscolorchanger.vue?vue&type=script&lang=js"
import style0 from "./emitLipscolorchanger.vue?vue&type=style&index=0&id=0b4958da&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4958da",
  null
  
)

export default component.exports